import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

type DataMode = 'mock' | 'live';

interface DataModeContextType {
  dataMode: DataMode;
  setDataMode: (mode: DataMode) => void;
  isMockMode: boolean;
}

const DataModeContext = createContext<DataModeContextType | undefined>(undefined);

export function DataModeProvider({ children }: { children: ReactNode }) {
  const [dataMode, setDataMode] = useState<DataMode>(() => {
    const saved = localStorage.getItem('admin_data_mode');
    return (saved as DataMode) || 'mock';
  });

  useEffect(() => {
    localStorage.setItem('admin_data_mode', dataMode);
  }, [dataMode]);

  return (
    <DataModeContext.Provider value={{ dataMode, setDataMode, isMockMode: dataMode === 'mock' }}>
      {children}
    </DataModeContext.Provider>
  );
}

export function useDataMode() {
  const context = useContext(DataModeContext);
  if (context === undefined) {
    throw new Error('useDataMode must be used within a DataModeProvider');
  }
  return context;
}
